/** @prettier */
import { API_ROOT, makeRequest } from "../services/qbankApi";
import useSWR from "swr";

const fetcher = (apiUrl: string) => {
    return makeRequest("GET", apiUrl).then((r) => r.json());
};

export type AuthorData = {
    fullName: string;
    userUuid: string;
    username: string;
};

export const useAuthors = (productId: string) =>
    useSWR<AuthorData[]>(`${API_ROOT}authors/product/${productId}`, fetcher);

export async function assignAuthor(questionUuid: string, userUuid: string) {
    await makeRequest("POST", `${API_ROOT}authors/assign`, {
        questionUuid,
        userUuid,
    });
}

export async function unassignAuthor(questionUuid: string, userUuid: string) {
    await makeRequest("POST", `${API_ROOT}authors/unassign`, {
        questionUuid,
        userUuid,
    });
}
